module.exports = __webpack_public_path__ + "img/Green Plastic.07f04d07.jpg";